module.exports = __webpack_public_path__ + "static/img/MA.3c291080.svg";